<template>
  <div class="container-subscribe">
    <template v-if="mobile">
      <div class="check-size-mb"></div>
    </template>
    <div class="primarylists list-mobile" v-if="mobile">
      <div class="titles clear" id="explore">
        <button class="btn-tast btn-next-1" @click="back()">
          <span>{{ $t("common.returnButton") }}</span>
        </button>
        <div class="title l">{{ $t("new.title143") }}</div>
      </div>
    </div>
    <div class="step-progress">
      <div class="progress-container">
        <div class="progress"></div>
        <div class="circle active">{{ DOMAIN_NAME !== domainNameCurrent ? $t("new.title162") : $t("new.title292") }}</div>
        <div v-if="totalPrice >= 0 && DOMAIN_NAME !== domainNameCurrent" class="circle">{{ $t("new.title164") }}</div>
        <div v-else class="circle">{{ DOMAIN_NAME !== domainNameCurrent ? $t("new.title228") : $t("new.title293") }}</div>
        <div class="circle">{{ $t("new.title163") }}</div>
      </div>
    </div>
    <div class="info-pay">
      <div class="header-tab">
        <h3 v-if="totalPrice >= 0 && DOMAIN_NAME !== domainNameCurrent">{{ $t("new.title165")}}</h3>
        <div class="main" :class="{'main_sanritsu': DOMAIN_NAME === domainNameCurrent}">
          <div class="form-sub">
            <form method="post" @submit.prevent="insertCourseRegisterUser()">
              <h1 class="title">{{DOMAIN_NAME !== domainNameCurrent ? $t("personSet.personInfo") : $t("personSet.personInfoSanritsu")}}</h1>
              <div class="row" v-if="userId == null">
                <div class="row">
                  <label for="fname"
                    >{{ $t("new.title170") }}<span>*</span></label
                  >
                </div>
                <div class="col-75">
                  <input type="text" id="fname" name="name" v-model="name" maxlength="100" @input="setErrorInputName" :class="{ 'error-border': errorName }"/>
                  <div>
                    <span :class="{ 'error-text': errorName }">{{ errorName }}</span>
                  </div>
                </div>
              </div>
              <div class="row" v-else-if="userId != null">
                <div class="row-else">
                  <label for="fname"
                    >{{ $t("new.title170") }}<span>*</span></label
                  >
                </div>
                <div class="col-75">
                  <label>{{ name }}</label>
                </div>
              </div>
              <div class="row" v-if="userId == null">
                <div class="row">
                  <label for="fname"
                    >{{ $t("new.title246") }}<span>*</span></label
                  >
                </div>
                <div class="col-75">
                  <input type="text" id="fname" name="email" v-model="email" maxlength="200" @input="setErrorInputEmail" :class="{ 'error-border': errorEmail }"/>
                  <div>
                    <span :class="{ 'error-text': errorEmail }">{{ errorEmail }}</span>
                  </div>
                </div>
              </div>
              <div class="row" v-else-if="userId != null">
                <div class="row-else">
                  <label for="fname"
                    >{{ $t("new.title171") }}<span>*</span></label
                  >
                </div>
                <div class="col-75" v-if="flagEmail">
                  <label>{{ email }}</label>
                </div>
                <div class="col-75" v-else>
                  <input type="text" id="fname" name="email" v-model="email" maxlength="200" @input="setErrorInputEmail" :class="{ 'error-border': errorEmail }" />
                  <div>
                    <span :class="{ 'error-text': errorEmail }">{{ errorEmail }}</span>
                  </div>
                </div>
              </div>
              <div class="row" v-if="userId == null || (userId != null && !flagEmail) ">
                <div class="row">
                  <label for="emailConfirm"
                    >{{ $t("new.title247") }}<span>*</span></label
                  >
                </div>
                <div class="col-75">
                  <input type="text" id="emailConfirm" name="emailConfirm" v-model="emailConfirm" maxlength="200" @input="setErrorInputEmailConfirm" :class="{ 'error-border': errorEmailConfirm }"/>
                  <div>
                    <span :class="{ 'error-text': errorEmailConfirm }">{{ errorEmailConfirm }}</span>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="row">
                  <label for="mobileSDT"
                    >{{ $t("new.title172") }}<span>*</span></label
                  >
                </div>
                <div class="col-75">
                  <input
                    type="text"
                    id="mobileSDT"
                    name="mobileSDT"
                    v-model="mobileSDT"
                    maxlength="13"
                    @input="setErrorInputMobileSDT"
                    :class="{ 'error-border': errorMobleSDT }"
                  />
                  <div>
                    <span :class="{ 'error-text': errorMobleSDT}">{{ errorMobleSDT }}</span>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="btn_form">
                  <input type="submit" :value="DOMAIN_NAME !== domainNameCurrent ? $t('new.title182') : $t('new.title274')" />
                  <button id="cancel_details" v-if="!mobile" @click="back()">
                    {{ $t("common.returnButton") }}
                  </button>
                </div>
              </div>
            </form>
          </div>
          <div class="info-transfer">
            <!-- <div class="info-bank" v-for="(item, index) in bankInfo" :key="index">
                            <div class="info">
                                <div class="info-logo">
                                </div>
                                <div class="info-value">
                                    <p >Chủ Tài khoản : </p>
                                    <p >{{ $t("new.title166") }} </p>
                                    <p >{{ $t("new.title167") }} </p>
                                </div>
                                <div class="info-value">
                                    <span>{{item.nameAccount}}</span>
                                    <span><b>{{item.numberBank}} </b></span>
                                    <span><b>{{item.nameBank}}</b></span>
                                </div>
                            </div>
                        </div>-->
            <h1 class="title">{{ $t("new.title224") }}</h1>
            <div class="info-head">
              <div class="lesson-name">
                <span scope="col">{{ $t("courseList.no") }}</span>
                <span scope="col">{{ $t("courseList.courseName") }}</span>
              </div>
              <div class="judge" scope="col">
                {{ $t("scoreStatistics.judge") }}
              </div>
              <div class="lesson-price">
                <span v-if="totalPrice >= 0" scope="col">{{ $t("new.title177") }}</span>
              </div>
            </div>
            <div class="info-lesson">
              <template v-for="(item, index) in listCourseId">
                <div class="info" :key="index">
                  <!-- Ten khoa hoc -->
                  <div class="lesson-name">
                    <span :data-label="$t('courseList.no')">{{
                      index + 1
                    }}</span>
                    <span :data-label="$t('courseList.courseName')">{{
                      item.courseName
                    }}</span>
                  </div>
                  <div
                    class="Stars"
                    :style="'--rating:' + item.courseEvaluate"
                  ></div>
                  <!-- Sao đánh giá -->
                  <div class="lesson-price">
                    <template v-if="item.coursePrice >= 0">
                      <span
                        v-if="item.offSelf != 0"
                        :data-label="$t('new.title177')"
                        ><span v-if="beforCurren">{{
                          $t("new.title121")
                        }}</span>
                        {{
                          (item.coursePrice - item.coursePriceDiscount)
                            .toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        }}
                        <span v-if="afterCurren">{{
                          $t("new.title121")
                        }}</span></span
                      >
                      <span v-else :data-label="$t('new.title177')"
                        ><span v-if="beforCurren">{{
                          $t("new.title121")
                        }}</span>
                        {{
                          item.coursePrice
                            .toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        }}
                        <span v-if="afterCurren">{{
                          $t("new.title121")
                        }}</span></span
                      >
                      <td
                        class="item-close"
                        style="width:10%"
                        v-on:click="
                          CloseItemCourse(
                            index,
                            item.coursePrice - item.coursePriceDiscount
                          )
                        "
                      >
                        &#10008;
                      </td>
                    </template>
                  </div>
                </div>
              </template>
            </div>
            <div class="synthetic" v-if="totalPrice >= 0">
              <span class="ty"
                ><span class="total_money"
                  >{{ $t("new.title168") }}: &nbsp;</span
                >
                <span class="total_money"
                  ><span v-if="beforCurren"> {{ $t("new.title121") }}</span>
                  {{
                    totalPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}
                  <span v-if="afterCurren" class="total_money">{{
                    $t("new.title121")
                  }}</span></span
                ></span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="myModal-error" class="modal" >
      <div class="modal-content  modal-error">
        <span v-on:click="CloseModalerorr()" class="close">&times;</span>
        <p class="messa-error">{{ $t("new.title284") }}</p>
        <p class="messa-error">{{ $t("new.title290") }}</p>
        <p class="messa-error">{{ $t("new.title289") }}</p>
        <div v-if="listCourseId.length > 1">
          <p v-for="(item, index) in courseRegistered" :key="index">
            <span class="course-name">• {{ $t("new.title283") }}</span>{{ item }}
          </p>
        </div>
        <div class="warning-button">
          <el-button
                round
                class="form_btn login_button1 btn-login"
                @click="nextPageNew()"
                >{{ $t("new.title286") }}</el-button
              >
          <el-button
                round
                class="form_btn login_button1 btn-login"
                @click="CloseModalerorr()"
                >{{ $t("new.title287") }}</el-button
              >
        </div>
      </div>
    </div>
    <!-- <cartCourse/> -->
    <loading class="loading--lesson" :showLoading="!isLoadData" />
  </div>
</template>

<script>
import cartCourse from "@/components/defineSelfCourse/detailsSelfCourse/cartCourse";
import loading from "@/components/loading/loading";
import domainName from "../../../env";
import { mapState, mapActions } from "vuex";
export default {
  name: "Subscribe",
  props: {
    msg: String
  },
  data() {
    return {
      errorName:"",
      errorEmail:"",
      errorEmailConfirm:"",
      errorMobleSDT:"",
      isLogin: true,
      data: null,
      cart: [],
      codeRegisterUser: [],
      bankInfo: [],
      totalPrice: 0,
      userId: null,
      transferContent: null,
      mobileSDT: null,
      name: null,
      email: null,
      emailConfirm: null,
      listCourseId: null,
      outlineInfo: eval("(" + this.$route.query.outlineInfo + ")"),
      type: eval("(" + this.$route.query.type + ")"),
      catalogId: eval("(" + this.$route.query.catalogId + ")"),
      checkLocal: false,
      messageSub: false,
      transferContent: Math.random()
        .toString(36)
        .substr(2, 9)
        .toUpperCase(),
      isLoadData: true,
      afterCurren: false,
      beforCurren: false,
      regExp: /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/,
      flagEmail: true,
      domainNameCurrent: window.location.host,
      DOMAIN_NAME: domainName.DOMAIN_NAME_SANRITSU,
      dataInsertUser: {},
      courseRegistered: [],
      flagCheckCourseRegistered: false,
    };
  },
  components: {
    cartCourse,
    loading
  },
  mounted() {
    //Lấy dữ liệu giỏ hàng
    if (
      localStorage.getItem("cart_" + this.$lang()) != [] ||
      localStorage.getItem("cart_" + this.$lang()) != ""
    ) {
      this.listCourseId = JSON.parse(localStorage.getItem("cart_" + this.$lang()));
      this.checkLocal = true;
    } else {
      this.listCourseId = null;
    }
    this.cart = JSON.parse(localStorage.getItem("cart_" + this.$lang()));
    if (this.listCourseId === null) {
      this.$router.push({
        path: "/home/selfCourse"
      });
    }
    //check user
    this.$autoLogin().then(
      () => {
        this.userId = this.$attrs.userId || window.sessionStorage.getItem("id");
        this.name = window.sessionStorage.getItem("name");
        this.email = window.sessionStorage.getItem("email");
        this.flagEmail = this.userId && !this.email ? false : true;
        this.isLogin = true;
      },
      () => {
        this.isLogin = false;
        this.userId = null;
      }
    );
    this.checkCurren();
    //Tổng số tiền các khóa học đã đăng ký
    if (this.listCourseId) {
      for (let index = 0; index < this.listCourseId.length; index++) {
        // if (this.DOMAIN_NAME === this.domainNameCurrent) {
            if (this.listCourseId[index].coursePrice < 0) {
              this.listCourseId[index].coursePrice = 0
            }
          // }
        if (this.listCourseId[index].coursePrice < 0) {
          continue;
        }
        if (this.listCourseId[index].offSelf != 0 && this.listCourseId[index].coursePrice > 0) {
          this.totalPrice +=
            this.listCourseId[index].coursePrice -
            this.listCourseId[index].coursePriceDiscount;
        } else {
          this.totalPrice += this.listCourseId[index].coursePrice;
        }
      }
    }
  },
  async created() {
    // await this.init();
  },
  computed: {
    mobile() {
      return this.$store.getters["header/mobile"];
    }
  },
  methods: {
    async init() {
      this.bankInfo = await this.getCourseBankInfo();
    },
    setErrorInputName () {
      this.errorName = "";
    },
    setErrorInputEmail () {
      this.errorEmail = "";
    },
    setErrorInputEmailConfirm () {
      this.errorEmailConfirm = "";
    },
    setErrorInputMobileSDT () {
      this.errorMobleSDT = "";
    },
  
    getCourseBankInfo() {
      return new Promise((resolve, reject) => {
        this.$api
          .post("/evaluate/getCourseBankInfo", {
            // courseId : this.outlineInfo.courseId
          })
          .then(response => {
            resolve(response.data);
          })
          .catch(err => {
            reject(err.response);
          });
      });
    },
    checkUserExistenceBeforeLogin(email) {
      return new Promise((resolve, reject) => {
        this.$api
          .post("/evaluate/checkUserExistenceBeforeLogin", {
            email : email
          })
          .then(response => {
            resolve(response.data);
          })
          .catch(err => {
            reject(err.response);
          });
      });
    },

    async insertCourseRegisterUser() {
      var flagCheckErrorRegexEmail = true;
      var flagErrorEmail = true;
      let flagCheckErrorCourseRegister = true;
      if (this.name == null || this.name.trim() == "") {
        this.errorName = window.vm.$i18n.t("new.title199");
        flagCheckErrorCourseRegister = false;
      } else {
        let lengthName = this.name.trim().length;
        if (lengthName < 2 || lengthName > 100) {
          this.errorName = window.vm.$i18n.t("new.title241");
          flagCheckErrorCourseRegister = false;
        }
      }
      
      if (this.email == null || this.email.trim() == "") {
        this.errorEmail = window.vm.$i18n.t("new.title200");
        flagCheckErrorCourseRegister = false;
      } else {
        if (!this.isLogin) {
          let userQuantityBeforeLogin = await this.checkUserExistenceBeforeLogin(this.email.trim());
          if (userQuantityBeforeLogin != 0) {
            this.errorEmail = window.vm.$i18n.t("new.title243");
            flagErrorEmail = false;
            flagCheckErrorCourseRegister = false;
          }
          if (flagErrorEmail) {
            const regexMail = /(^\s*([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})\s*$)/;
            if (!regexMail.test(this.email)) {
            this.errorEmail = window.vm.$i18n.t("new.title242");
            flagCheckErrorRegexEmail = false;
            flagCheckErrorCourseRegister = false;
            }
          }
        }
      } 

      if (!this.isLogin) {
        this.errorEmailConfirm = "";
        if ((this.emailConfirm == null || this.emailConfirm.trim() == "")) {
          this.errorEmailConfirm = window.vm.$i18n.t("new.title245");
          flagCheckErrorCourseRegister = false;
        } else {
          if (this.email != null && this.email != '') {
            if (this.emailConfirm.trim() != this.email.trim() && (!this.flagEmail || this.userId == null)) {
              this.errorEmailConfirm = window.vm.$i18n.t("new.title235");
              flagCheckErrorCourseRegister = false;
            } else if (!flagCheckErrorRegexEmail) {
              this.errorEmailConfirm = window.vm.$i18n.t("new.title242");
              flagCheckErrorCourseRegister = false;
            } else if (!flagErrorEmail) {
                this.errorEmailConfirm = window.vm.$i18n.t("new.title243");
                flagCheckErrorCourseRegister = false;
            }
          } else {
            this.errorEmailConfirm = window.vm.$i18n.t("new.title235");
            flagCheckErrorCourseRegister = false;
          }
        }
      }
      if (this.mobileSDT == null || this.mobileSDT.trim() == "") {
        this.errorMobleSDT = window.vm.$i18n.t("new.title201");
        flagCheckErrorCourseRegister = false;
      } else {
        const checkNumber = /^\s*\+?[0-9]{10,12}\s*$/;
        if (!checkNumber.test(this.mobileSDT)) {
         this.errorMobleSDT = window.vm.$i18n.t("new.title202");
         flagCheckErrorCourseRegister = false;
        } 
      }
      if (!flagCheckErrorCourseRegister) {
        return;
      }
      // Check user registered those course
      if (this.listCourseId.length > 0) {
        await this.$api
          .post("/evaluate/checkUserIsRegisterCourse", {
            email: this.email.trim(),
            listCourseId: this.listCourseId
          })
          .then(response => {
            this.courseRegistered = response.data;
            this.flagCheckCourseRegistered = false;
            if (this.listCourseId.length == 1) {
              if (this.courseRegistered.length > 0) {
                // this.$el_alert_type(window.vm.$i18n.t("new.title283"), "warning");
                this.OpenModalerorr();
                this.flagCheckCourseRegistered = true;
              }
            } else {
              if (this.courseRegistered.length > 0) {
                this.OpenModalerorr();
                this.flagCheckCourseRegistered = true;
              }
            }
          });
      }
      if (this.flagCheckCourseRegistered) {
        console.log(this.flagCheckCourseRegistered);
        return;
      }
      if (this.listCourseId.length > 0) {
        let coursesBankInfoBought = [];
        if (this.totalPrice > 0) {
          coursesBankInfoBought = await this.getCourseBankInfoBought();
        }
        this.isLoadData = false;
        if (this.DOMAIN_NAME === this.domainNameCurrent) {
            this.dataInsertUser = {
              userId: this.userId,
              userName: this.name.trim(),
              email: this.email.trim(),
              mobile: this.mobileSDT.trim(),
              transferContent: null,
              listCourseId: this.listCourseId,
              money: this.totalPrice,
              coursesBankInfoBought: coursesBankInfoBought,
              languageType: this.$lang()
          }
          // this.updateData(this.dataInsertUser)
          const listCoursIdNew = []
          this.listCourseId.map((value, index) => {
            listCoursIdNew.push(value.courseId)
          })
          this.$api.post("/evaluate/checkUserApplyCourse", {
              userId: this.userId,
              userName: this.name.trim(),
              email: this.email.trim(),
              mobile: this.mobileSDT.trim(),
              transferContent: null,
              listCourseId: this.listCourseId,
              money: this.totalPrice,
              coursesBankInfoBought: coursesBankInfoBought,
              languageType: this.$lang()
            }).then(res => {
              localStorage.setItem('checkApplyCourse', res.data)
            })
          localStorage.setItem("dataInsert", JSON.stringify(this.dataInsertUser))
          this.nextPageSuccessSelfCourse();
        } else {
          this.$api
          .post("/evaluate/insertCourseRegisterUser", {
            userId: this.userId,
            userName: this.name.trim(),
            email: this.email.trim(),
            mobile: this.mobileSDT.trim(),
            transferContent: null,
            listCourseId: this.listCourseId,
            money: this.totalPrice,
            coursesBankInfoBought: coursesBankInfoBought,
            languageType: this.$lang()
          })
          .then(response => {
            this.isLoadData = true;
            localStorage.clear();
            this.codeRegisterUser = response.data;
            this.nextPageSuccessSelfCourse();
          })
          .catch(err => {
            this.isLoadData = true;
            // console.log(err);
          });
        }
        
      } else {
        this.messageSub = true;
      }
    },

    async getCourseBankInfoBought() {
      const listCoursesBought = await this.getListCourseBought();
      const courses = listCoursesBought.map(course => {
        return {
          companyId: course.courseBankInfo[0].companyId || null,
          ...course
        };
      });

      let results = [];
      courses.forEach(course => {
        const companyExist = results.some(
          el => el.companyId === course.companyId
        );

        if (companyExist) {
          results.forEach(el => {
            if (el.companyId == course.companyId && course.price >= 0) {
              el.totalPrice += course.price;
            }
          });
        } else {
          const obj = {
            companyId: course.companyId,
            ...course.courseBankInfo[0],
            totalPrice: course.price
          };
          results.push(obj);
        }
      });

      return results;
    },

    getListCourseBought() {
      let listCourseName = [];
      this.listCourseId.forEach(value => {
        let objCourse = {};
        objCourse.courseName = value.courseName;
        objCourse.id = value.courseId
        if (value.offSelf != 0 && value.coursePrice > 0) {
          objCourse.price = value.coursePrice - value.coursePriceDiscount;
        } else {
          objCourse.price = value.coursePrice;
        }
        objCourse.courseEvaluate = value.courseEvaluate;
        objCourse.courseBankInfo = value.courseBankInfo;
        listCourseName.push(objCourse);
      });
      return listCourseName;
    },
    async nextPageNew() {
      if ( this.DOMAIN_NAME === this.domainNameCurrent ) {
        let coursesBankInfoBought = [];
      if (this.totalPrice > 0) {
          coursesBankInfoBought = this.getCourseBankInfoBought();
        }
        this.isLoadData = false;
        // if (this.DOMAIN_NAME === this.domainNameCurrent) {
            this.dataInsertUser = {
              userId: this.userId,
              userName: this.name.trim(),
              email: this.email.trim(),
              mobile: this.mobileSDT.trim(),
              transferContent: null,
              listCourseId: this.listCourseId,
              money: this.totalPrice,
              coursesBankInfoBought: coursesBankInfoBought,
              languageType: this.$lang()
          }
        // }
        localStorage.setItem("dataInsert", JSON.stringify(this.dataInsertUser))
        this.nextPageSuccessSelfCourse();
      } else {
          if (this.listCourseId.length > 0) {
          let coursesBankInfoBought = [];
          if (this.totalPrice > 0) {
            coursesBankInfoBought = await this.getCourseBankInfoBought();
          }
          this.isLoadData = false;
          if (this.DOMAIN_NAME === this.domainNameCurrent) {
              this.dataInsertUser = {
                userId: this.userId,
                userName: this.name.trim(),
                email: this.email.trim(),
                mobile: this.mobileSDT.trim(),
                transferContent: null,
                listCourseId: this.listCourseId,
                money: this.totalPrice,
                coursesBankInfoBought: coursesBankInfoBought,
                languageType: this.$lang()
            }
            // this.updateData(this.dataInsertUser)
            const listCoursIdNew = []
            this.listCourseId.map((value, index) => {
              listCoursIdNew.push(value.courseId)
            })
            this.$api.post("/evaluate/checkUserApplyCourse", {
                userId: this.userId,
                userName: this.name.trim(),
                email: this.email.trim(),
                mobile: this.mobileSDT.trim(),
                transferContent: null,
                listCourseId: this.listCourseId,
                money: this.totalPrice,
                coursesBankInfoBought: coursesBankInfoBought,
                languageType: this.$lang()
              }).then(res => {
                localStorage.setItem('checkApplyCourse', res.data)
              })
            localStorage.setItem("dataInsert", JSON.stringify(this.dataInsertUser))
            this.nextPageSuccessSelfCourse();
          } else {
            this.$api
            .post("/evaluate/insertCourseRegisterUser", {
              userId: this.userId,
              userName: this.name.trim(),
              email: this.email.trim(),
              mobile: this.mobileSDT.trim(),
              transferContent: null,
              listCourseId: this.listCourseId,
              money: this.totalPrice,
              coursesBankInfoBought: coursesBankInfoBought,
              languageType: this.$lang()
            })
            .then(response => {
              this.isLoadData = true;
              localStorage.clear();
              this.codeRegisterUser = response.data;
              this.nextPageSuccessSelfCourse();
            })
            .catch(err => {
              this.isLoadData = true;
              // console.log(err);
            });
          }
        }
      }
    },
    nextPageSuccessSelfCourse() {
      const listCourseBought = this.getListCourseBought();
      this.$router.push({
        path: "/home/subscribeSuccessSelfCourse",
        query: {
          code: this.codeRegisterUser,
          name: this.name,
          email: this.email,
          mobile: this.mobileSDT,
          totalPrice: this.totalPrice,
          listCourseName: JSON.stringify(listCourseBought)
        }
      });
    },
    // Curency position
    checkCurren() {
      if (this.$lang()) {
        if (this.$lang() == 3 || this.$lang() == 1) {
          this.beforCurren = true;
        } else {
          this.afterCurren = true;
        }
      }
    },
    back() {
      if (this.outlineInfo) {
        this.$router.push({
          path: "/home/detailsSelfCourse",
          query: {
            outlineInfo: JSON.stringify(this.outlineInfo)
          }
        });
      } else if (this.type) {
        this.$router.push({
          path: "/home/selfCourse",
          query: {
            type: this.type,
            catalogId: this.catalogId
          }
        });
      } else {
        this.$router.push({
          path: "/home/index"
        });
      }
    },
    //Đóng từng item khóa học
    CloseItemCourse(id, price) {
      this.listCourseId.splice(id, 1);
      if (this.totalPrice > 0 && price >= 0 ) {
        this.totalPrice -= price;
      }
      this.saveCats();
    },
    saveCats() {
      // for save in local storage set the below code
      let parsed = JSON.stringify(this.listCourseId);
      localStorage.setItem("cart_" + this.$lang(), parsed);

      if (localStorage.getItem("cart_" + this.$lang())) {
        this.listCourseId = JSON.parse(localStorage.getItem("cart_" + this.$lang()));
        // totall price in shopping cart
        this.totalPrice = 0;
        for (let index = 0; index < this.listCourseId.length; index++) {
          if (this.DOMAIN_NAME === this.domainNameCurrent) {
            if (this.listCourseId[index].coursePrice < 0) {
              this.listCourseId[index].coursePrice = 0
            }
          }
          if (this.listCourseId[index].coursePrice < 0) {
            continue;
          }
          if (this.listCourseId[index].offSelf != 0 && this.listCourseId[index].coursePrice > 0) {
            this.totalPrice +=
              this.listCourseId[index].coursePrice -
              this.listCourseId[index].coursePriceDiscount;
          } else {
            this.totalPrice += this.listCourseId[index].coursePrice;
          }
        }
      }
      if (this.listCourseId.length == 0) {
        this.back();
      }
    },
    OpenModalerorr() {
      document.getElementById("myModal-error").style.display = "block";
    },
    CloseModalerorr() {
      document.getElementById("myModal-error").style.display = "none";
    },
    ...mapActions("applyCourse", ['updateData']),
  }
};
</script>
<style>
.custom-warning-message {
    white-space: nowrap !important;
}
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
* {
  box-sizing: border-box;
  font-size: 16px;
}
.container-subscribe {
  padding: 40px 0px;
}
.step-progress {
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0px 40px 40px 40px;
}
.progress-container {
  display: flex;
  justify-content: space-between;
  position: relative;
  max-width: 100%;
  width: 550px;
}
.progress-container::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 0;
  height: 4px;
  width: 100%;
  background-color: #bbbbbb;
  z-index: -1;
}
.progress {
  position: absolute;
  top: 50%;
  left: 0;
  width: 0;
  height: 4px;
  background-color: var(--line-border-fill);
  z-index: -1;
  transition: all 0.5s ease-in;
}
.circle {
  background-color: #fff;
  height: 100px;
  width: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  transition: all 0.4s ease-in;
  border: 7px solid #aaaaaa;
}
.circle.active {
  border-color: #0071c5;
  background-color: #fff;
  box-shadow: 0px 0px 31px -2px rgba(0, 105, 37, 0.62);
}
.header-tab h3 {
  background-color: #dddddd;
  padding: 10px;
  color: #000000;
  font-weight: bolder;
  margin-bottom: 10px;
  font-size: 20px;
}
.info-pay .main {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  margin: 2%;
  background: #ffffff !important;
  border-radius: 30px;
}
.info-pay .main .info-transfer {
  padding: 20px 20px 20px 20px;
  line-height: 25px;
  width: 40%;
  min-width: 430px;
}
.info-pay .main .info-transfer .info-lesson {
  display: flex;
  flex-direction: column;
  height: 200px;
  overflow-y: auto;
}
.info-pay .main .info-transfer .info-lesson .info {
  display: flex;
  justify-content: space-between;
  padding-left: 5%;
  margin: 15px 0px;
  border-bottom: 1px solid #0071c5;
}

.info-pay .main .info-transfer .info-lesson .info .lesson-name {
  display: flex;
  width: 50%;
  min-width: 140px;
  column-gap: 20px;
  font-size: 20px;
  font-weight: 600;
  color: #0071c5;
}
.info-pay .main .info-transfer .info-lesson .info .lesson-name span {
  word-break: break-word;
}

.info-pay .main .info-transfer .info-lesson .info .lesson-price {
  display: flex;
  font-weight: bold;
  font-size: 20px;
  color: #051367;
  width: 40%;
  min-width: 110px;
  justify-content: flex-end;
}
.info-pay .main .info-transfer .info .Stars {
  width: 20%;
  min-width: 100px;
}
.info-pay .main .info-transfer .info-head {
  display: flex;
  justify-content: space-between;
  padding: 0% 4%;
  margin: 20px 0px;
  font-size: 20px;
  font-weight: 600;
  color: #ffffff;
  background: #0071c5;
}
.info-pay .main .info-transfer .info-head .lesson-name {
  display: flex;
  width: 50%;
  column-gap: 5px;
  font-size: 20px;
  font-weight: 600;
}
.info-pay .main .info-transfer .info-head .judge {
  width: 80px;
}
.info-pay .main .info-transfer .info-head .lesson-price {
  display: flex;
  font-weight: bold;
  font-size: 20px;
  width: 40%;
  justify-content: flex-end;
}
.info-pay .main .info-transfer .info-head .Stars {
  width: 20%;
}
.info-pay .main .info-transfer .title {
  text-align: center;
  font-weight: 600;
  font-size: 30px;
}
.info-pay .main .info-transfer .synthetic {
  background: #0071c5;
  height: 50px;
  margin-top: 36px;
  display: flex;
  border-radius: 4px;
  padding: 0% 5%;
  justify-content: flex-end;
}
.info-pay .main .info-transfer .synthetic #transfer-code {
  text-align: center;
  align-items: center;
  font-size: 22px;
  color: rgb(187, 5, 5);
  font-family: Verdana, Geneva, Tahoma, sans-serif;
  font-weight: 600;
}
.info-pay .main .info-transfer .ty {
  color: #501367;
}
.info-pay .main .form-sub {
  display: flex;
  padding: 20px;
  font-size: 18px;
  width: 45%;
  justify-content: flex-start;
}
.info-pay .main .form-sub form {
  width: 100%;
}
.info-pay .main .form-sub .title {
  font-size: 30px;
}
/* Style inputs, select elements and textareas */
input[type="text"] {
  width: 100%;
  padding: 12px;
  border: 1px solid #0071c5;
  border-radius: 4px;
  box-sizing: border-box;
  resize: vertical;
}

/* Style the label to display next to the inputs */
label {
  padding: 12px 12px 12px 0;
  display: inline-block;
}
label span {
  color: rgb(241, 12, 12);
}
/* Style the submit button */
input[type="submit"] {
  background-color: #0071c5;
  color: #ffffff;
  padding: 12px 20px;
  border: none;
  box-shadow: 5px 5px 5px #bbbbc3;
  border-radius: 4px;
  cursor: pointer;
  /* display: block; */
  margin: 0px auto;
  font-size: 20px;
  font-weight: bold;
}
.form-sub form .attention {
  color: #606266;
  font-size: 16px;
  text-align: center;
  padding: 20px 0px;
}
/* Style the container */
.container {
  border-radius: 5px;
  background-color: #f2f2f2;
  padding: 20px;
}

/* Floating column for labels: 25% width */
.col-25 {
  float: left;
  width: 25%;
  margin-top: 6px;
}

/* Floating column for inputs: 75% width */
.col-75 {
  /* float: left; */
  width: 100%;
}
.col-75 div {
  /* Set a fixed height for the div containing the error message */
  height: 25px;
  margin-bottom: 0;
  overflow: hidden;
}

.col-75 span {
  /* Hide the error message when there is no error */
  display: none;
}

/* Display the error message and set the text color to red when there is an error */
.col-75 span.error-text {
  display: inline-block;
  color: red;
  margin-top: 9px;
  font-size: 13.5px;
}

/* When there is an error, the border will be red */
.error-border {
  border: 1px solid red !important;
}
/* Clear floats after the columns */
.row:after {
  content: "";
  display: table;
  clear: both;
}
.row-else {
  float: left;
}
table {
  border: 1px solid #ccc;
  border-collapse: collapse;
  margin: 0 auto;
  padding: 0;
  width: 100%;
  table-layout: fixed;
}

table caption {
  font-size: 1.5em;
  margin: 0.5em 0 0.75em;
}

table tr {
  background-color: #f8f8f8;
  border: 1px solid #ddd;
  padding: 0.35em;
}

table th,
table td {
  padding: 0.625em;
  text-align: center;
  font-weight: 600;
}
table .total_price {
  text-align: right !important;
  font-weight: 600;
}
table .total_price span {
  color: #cb0d0d;
}
table th {
  font-size: 0.85em;
  letter-spacing: 0.1em;
  text-transform: inherit;
  background-color: #007aff;
  color: #fff;
}
/* Responsive layout - when the screen is less than 600px wide, make the two columns stack on top of each other instead of next to each other */
@media screen and (max-width: 600px) {
  table {
    border: 0;
  }

  table caption {
    font-size: 1.3em;
  }

  table thead {
    border: none;
    clip: rect(0 0 0 0);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    width: 1px;
  }

  table tr {
    border-bottom: 3px solid #ddd;
    display: block;
    margin-bottom: 0.625em;
  }

  table td {
    border-bottom: 1px solid #ddd;
    display: block;
    font-size: 0.8em;
    text-align: right;
  }

  table td::before {
    /*
    * aria-label has no advantage, it won't be read inside a table
    content: attr(aria-label);
    */
    content: attr(data-label);
    float: left;
    font-weight: bold;
    text-transform: uppercase;
  }

  table td:last-child {
    border-bottom: 0;
  }
  .col-25,
  .col-75,
  input[type="submit"] {
    width: 100%;
    margin-top: 0;
  }
  .info-pay .main .info-transfer {
    padding: 0px 40px;
    font-size: 30px;
    width: calc(100% - 10px) !important;
    min-width: 400px !important;
    /* border: 1px solid #0071c5; */
  }
  .info-pay .main .form-sub {
    padding: 20px;
    font-size: 30px;
    width: 100%;
  }
  .info-pay .main .info-transfer .info-lesson {
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
  }
}
@media screen and (max-width: 1200px) {
  .info-pay .main .info-transfer .info-lesson {
    display: flex;
    flex-wrap: nowrap;
  }
}
::-webkit-scrollbar {
  width: 20px;
}

/* Track */
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px grey;
  border-radius: 10px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #0071c5;
  border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #025a9e;
}

/* khoá học */
.primarylists {
  margin: 2% 5% 2% 5%;
}
.primarylists .lessons.lessons-new ul li {
  /* width: calc(25% - 16px)!important; */
  width: 100% !important;
  height: fit-content;
  display: flex;
  column-gap: 40px;
  padding: 20px !important;
  flex-wrap: wrap;
}
.primarylists .total_price {
  background: #0071c5;
  margin: 10px 0px 10px 0px;
  padding: 0px 20px 0px 20px;
  width: 100%;
  height: 70px;
  display: flex;
  border-radius: 30px;
  justify-content: flex-end;
  align-items: center;
}
.primarylists .paging {
  background: #0071c5;
  height: 5px;
  margin: 20px 0px;
  width: 100%;
}
.primarylists .total_price .price_style {
  font-weight: bold;
  font-size: 25px;
  color: #ffffff;
}
.lessons {
  margin-top: 0px;
}
.Stars {
  --star-size: 20px;
  --star-color: #a8a8a8;
  --star-background: #ff6d35;
  --percent: calc(var(--rating) / 5 * 100%);
  display: inline-block;
  font-size: var(--star-size);
  font-family: Times;
  line-height: 1;
}
.Stars::before {
  content: "★★★★★";
  letter-spacing: 3px;
  background: linear-gradient(
    90deg,
    var(--star-background) var(--percent),
    var(--star-color) var(--percent)
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.like-ps {
  top: 0px !important;
  left: 2px !important;
}
.primarylists > ul > li {
  padding-bottom: 50px;
  overflow: hidden;
}
.vn .primarylists .lessons ul li > div {
  padding: 0;
}
.primarylists ul li .titles {
  height: 35px;
  width: 1000px;
  padding-bottom: 5px;
  color: black;
  margin-bottom: 10px;
  display: flex;
  inline-size: max-content;
}
.primarylists ul li .titles img {
  width: 32px;
  height: 32px;
  margin-top: 1px;
}
.primarylists ul li .titles .title {
  font-size: 24px;
  padding: 0 20px 0 10px;
  line-height: 35px;
  cursor: auto;
  font-weight: bold;
}
.primarylists ul li .titles .more {
  font-size: 16px;
  line-height: 35px;
  cursor: auto;
  padding-right: 20px;
}
.primarylists ul li .titles .more a {
  color: black;
}
.more a {
  color: #fff !important;
}
.primarylists ul li .titles .title:hover {
  color: #02adff;
}
.primarylists ul li .titles .more :hover {
  color: #02adff;
}
.primarylists .secondlist {
  height: 100%;
  font-size: 16px;
}
.primarylists .secondlist ul li {
  float: left;
  padding: 3px 10px;
  cursor: pointer;
  margin-right: 16px;
  background: #666;
  border-radius: 15px;
  color: white;
}
.primarylists .secondlist ul li.choose {
  background: lightskyblue;
}
.primarylists .lessons ul {
  height: auto;
  overflow: hidden;
  transform: translateX(5px);
}
.primarylists .lessons ul li {
  width: 350px;
  height: fit-content;
  float: left;
  box-sizing: border-box;
  background: #ffffff !important;
  background-clip: padding-box;
  margin: 10px 0px 10px 0px;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 5px 5px 5px #bbbbc3 !important;
}
.primarylists .lessons ul li .img {
  height: 210px !important;
  width: 20% !important;
  min-width: 250px;
}
.primarylists .lessons ul li .img img {
  width: 100%;
  transition: all 0.25s ease-in-out;
  -moz-transition: all 0.25s ease-in-out;
  -webkit-transition: all 0.25s ease-in-out;
  -o-transition: all 0.25s ease-in-out;
}
.primarylists .lessons .lessontitle {
  padding: 10px 10px 0px 10px !important;
  margin: 5px 0 0px !important;
  color: #f8f8f8;
  font-size: 15px;
  cursor: auto;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
}
.primarylists .lessons .lessontitle:hover {
  color: lightskyblue;
}
.primarylists .lessons .nameIndex:hover {
  color: lightskyblue !important;
}
.primarylists .lessons .price {
  width: 20%;
  min-width: 250px;
  position: unset !important;
}
.primarylists .lessons .bankInfomation {
  width: 55%;
  min-width: 430px;
  height: fit-content !important;
  position: unset !important;
}
.primarylists .lessons .info-bank {
  display: flex;
  flex-direction: column;
}
.primarylists .lessons .info-bank .info {
  margin: 10px;
  border-radius: 15px;
  padding: 10px;
  background: #e8f9fd;
  display: flex;
  column-gap: 20px;
  align-items: center;
}
.primarylists .lessons .info-bank .info .info-logo {
  background-image: url("../../../static/images/ic-bank1.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  display: flex;
  flex-wrap: wrap;
  float: left;
  font-size: 18px;
  min-width: 55px;
  height: 55px;
}
.primarylists .lessons .info-bank .info .info-value {
  display: flex;
  column-gap: 20px;
  min-width: 321px;
  align-items: center;
  justify-content: space-between;
  color: #051367;
}
.primarylists .lessons .borderIndex {
  border-bottom: 1px solid #0071c5;
}
.primarylists .lessons .price .priceAndDiscount {
  background: white;
  margin-bottom: 10px;
  height: auto;
  width: 100%;
  display: flex;
  border-radius: 10px;
  justify-content: space-between;
}
.primarylists .lessons .price .priceAndDiscount div {
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
}
.primarylists .lessons .price .priceAndDiscount .priceValue {
  font-weight: bold;
  font-size: 20px;
  color: #051367;
  width: 100%;
  column-gap: 5px;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: flex-end;
}
.primarylists .lessons .price .lastPrice {
  background: #0071c5;
  margin-top: 10px;
  height: 50px;
  width: 100%;
  display: flex;
  border-radius: 30px;
  align-items: center;
  justify-content: center;
}
.primarylists .lessons .price .lastPrice .priceIndex {
  font-weight: bold;
  font-size: 20px;
  color: #ffffff;
}
.primarylists .lessons .startAndName .nameIndex {
  font-size: 20px;
  font-weight: 600;
  color: #0071c5;
}
.primarylists .lessons .introduce {
  padding: 0 10px;
  color: #999;
  font-size: 12px;

  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
}
.container,
.bigCourse {
  width: 1200px;
  margin: 0 auto;
}
.free-course {
  color: #cb0d0d;
  padding-right: 20px;
}
@media screen and (min-width: 1000px) and (max-width: 1200px) {
  .container,
  .bigCourse {
    width: 1000px;
  }
}
@media screen and (min-width: 800px) and (max-width: 1000px) {
  .container,
  .bigCourse {
    width: 800px;
  }
}
@media screen and (min-width: 600px) and (max-width: 800px) {
  .container,
  .bigCourse {
    width: 600px;
  }
}
@media screen and (max-width: 600px) {
  .circle {
    width: 80px;
    height: 80px;
  }
  .container,
  .bigCourse {
    width: 400px;
  }
}
.vaa :hover {
  transform: scale(1.05, 1.05);
  cursor: auto;
}
.disabledCourse {
  display: none;
}
.primarylists .lessons .lessontitle_MB {
  display: none;
}
/* style MB */
@media (max-width: 480px) {
  .primarylists .total_price {
    justify-content: center;
  }
  .info-pay .main .info-transfer .synthetic {
    justify-content: center;
  }
  .primarylists .lessons.lessons-new ul li {
    width: 100% !important;
    height: fit-content !important;
    display: flex;
    column-gap: 40px;
    flex-wrap: wrap;
  }
  .primarylists .lessons ul li .img {
    width: calc(100% - 10px) !important;
  }
  .primarylists .lessons .info-bank {
    display: flex;
    flex-direction: column;
  }
  .primarylists .lessons .info-bank p {
    width: 100%;
    margin-bottom: 10px;
  }
  .primarylists .lessons .bankInfomation {
    width: calc(100% - 10px) !important;
    height: fit-content !important;
    min-width: 0px !important;
    position: unset !important;
  }
  .primarylists .lessons .info-bank .info {
    margin: 5px 0px;
    border-radius: 15px;
    padding: 10px;
    background: #e8f9fd;
    display: flex;
    column-gap: 10px;
    align-items: flex-start;
  }
  .primarylists .lessons .info-bank .info .info-logo {
    background-image: url("../../../static/images/ic-bank1.png");
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    display: flex;
    flex-wrap: wrap;
    float: left;
    font-size: 18px;
    min-width: 55px;
    height: 55px;
  }
  .primarylists .lessons .info-bank .info .info-value {
    display: flex;
    column-gap: 5px;
    align-items: center;
    flex-wrap: wrap;
    justify-content: flex-start;
    color: #051367;
    min-width: 0px !important;
  }
  .info-pay .main {
    width: calc(100% - 10px) !important;
  }
  .info-pay .main .info-transfer .info-head .judge {
    visibility: hidden;
    display: none;
  }
  .info-pay .main .info-transfer .info-lesson .info .Stars {
    visibility: hidden;
    display: none;
  }
  .primarylists .lessons .price {
    width: calc(100% - 10px) !important;
  }
  /*
    .primarylists .lessons .borderIndex{
        border-bottom: none!important;
    }
    .primarylists .lessons .price .lastPrice .priceIndex {
        float: none !important;
    }
    .Stars {
        --star-size: 25px !important;
    }
    .primarylists .lessons .lessontitle {
        padding: 0px 5px 0px 5px !important;
        margin: 0px 0 15px!important;
    }
    .primarylists .lessons .lessontitle_PC {
        display: none!important;;
    }
    .primarylists .lessons .lessontitle_MB {
        display: unset!important;
    }
    .primarylists .lessons .bankInfomation {
        display: unset!important;
    }
    .priceIndex {
        padding: 0px 5px 0px 5px !important;
    }
    .startIndex {
        padding: 0px 5px 0px 5px !important;
        float: right;
    }
    .btn_form {
    text-align: center;
    width:100% !important;
    float:none;
    margin-top:10px;
    } */
}
@media screen and (min-width: 481px) and (max-width: 710px) {
  .primarylists .lessons .price .lastPrice {
    float: none !important;
  }
  .primarylists .lessons .price .lastPrice .priceIndex {
    float: none !important;
  }
  .btn_form {
    text-align: center;
    width: 100% !important;
    float: none;
    margin-top: 10px;
  }
}
.synthetic .ty {
  display: flex;
  align-items: center;
}
.total_money {
  font-weight: bold;
  font-size: 24px;
  color: #ffffff;
}
.btn_cancel {
  width: 95%;
}
#cancel_details {
  padding: 12px 20px;
  background-color: #9f9f9f;
  box-shadow: 5px 5px 5px #bbbbc3;
  border-radius: 4px;
  text-decoration: none;
  color: #ffff;
  font-size: 20px;
  margin: 10px 10px 0px 0px;
  font-weight: 600;
  border: none;
}
#hidden {
  visibility: hidden;
  display: none;
}
.btn_cancel {
  border-color: #fff !important;
}
.btn_form {
  margin-top: 10px;
}
@media (max-width: 1112px) {
  #explore .title {
    padding-left: 55px;
  }
}
.primarylists .titles .title {
  padding: 0 0px 0 10px;
}
.btn_form {
  text-align: center;
  margin-top: 10px;
}
.cart_moblie {
  width: unset !important;
}

.item-close {
  font-size: 20px;
  color: rgb(230, 5, 5);
  margin-left: 5%;
  cursor: pointer;
}

@media (max-height: 812px) {
  .check-size-mb {
    padding-top: 40px;
  }
}
/* The Modal (background) */
.modal {
  display: none; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 1; /* Sit on top */
  padding-top: 100px; /* Location of the box */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0, 0, 0); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
}
.warning-button {
  text-align: center;
}
/* Modal Content */
.modal-content {
  background-color: #fefefe;
  margin: auto;
  padding: 20px;
  border: 1px solid #888;
  width: 60%;
  border-radius: 10px;
  position: relative;
}
.modal-error {
  width: 54% !important;
}
.messa-error {
  text-align: left;
  font-size: 16px;
  line-height: 1.5;
}
.course-name {
  padding-left: 20px !important;
  font-size: 16px;
  line-height: 1.5;
}
.close {
  color: #fff;
  float: right;
  font-size: 15px;
  font-weight: bold;
  border: 1px solid;
  /* border-color: gray; */
  border-radius: 7px;
  padding: 5px;
  background-color: #25368c;
  cursor: pointer;
  position: absolute;
  right: 5px;
  top: 5px;
}

.main_sanritsu {
  margin-top: 38px !important;
  align-items: start !important;
}

.main_sanritsu .info-transfer {
  padding-top: 73px !important;
}
</style>



// WEBPACK FOOTER //
// src/views/defineSelfCourse/subscribeSelfCourse.vue